import $ from "jquery";
import "slick-carousel";

$(".block-sticky-performance-peaks-mobile .slider").slick({
  adaptiveHeight: true,
  arrows: false,
  dots: true,
  fade: true
});
